module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_24.95952d70.pdf";